import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
    return (
        <footer
            className="border-t-2 border-un-onyx bg-un-berry text-white"
            data-testid="site-footer"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8 flex flex-col md:flex-row items-center md:items-center justify-between gap-4 text-center md:text-left">
                <div className="un-mono text-xs tracking-wider font-bold" data-testid="footer-copyright">
                    COPYRIGHT UNCLONED MEDIA 2026
                </div>
                <div className="flex items-center gap-6">
                    <Link
                        to="/legal"
                        className="un-mono text-xs tracking-wider font-bold text-white hover:text-un-lime transition-colors"
                        data-testid="footer-legal-link"
                    >
                        LEGAL
                    </Link>
                    <a
                        href="https://www.skool.com/uncloned-8397"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="un-mono text-xs tracking-wider font-bold text-white hover:text-un-lime transition-colors"
                        data-testid="footer-uncloned-link"
                    >
                        UNCLONEDMARKETING.COM
                    </a>
                </div>
            </div>
        </footer>
    );
};
